import { render, staticRenderFns } from "./FormTemplatesFormEditor.vue?vue&type=template&id=8b3d8852&"
import script from "./FormTemplatesFormEditor.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesFormEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplatesFormEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports